import { post,get,postJson,put} from '../axios'
import { get as getPoint} from '../axios2'

/**
 * 商品模块及分析
 */

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/ware'
const RESOURCE_BASE_PATH = '/ware'
/*
 * 商品复购分析
 * */
export const reBuy = p => get(`${RESOURCE_BASE_PATH}/analyze/reBuy`, p);

/*
 * 商品复购分析数据导出
 * */
export const reBuyExport = p => get(`${RESOURCE_BASE_PATH}/export/reBuy`, p);

/*
 *  获取商品连带分析营销客户的电话 
 * */
export const getBindPhones = p => get(`${RESOURCE_BASE_PATH}/getBindPhones`, p);

/*
 * 商品连带分析
 * */
export const bindSell = p => get(`${RESOURCE_BASE_PATH}/analyze/bindSell/v2`, p);

/*
 *获取商品复购分析营销客户的电话
 * */
export const getReBuyBuyerPhones = p => get(`${RESOURCE_BASE_PATH}/getReBuyBuyerPhones`, p);


/*
 * 获取店铺类目
 * */
// export const getSellercats = p => get(`${RESOURCE_BASE_PATH}/category/all`, p);
export const getSellercats = p => getPoint(`${RESOURCE_BASE_PATH}/category/all`, p);

/*
 * 获取店铺商品
 * */
export const getTaobaoItemList = p => get(`${RESOURCE_BASE_PATH}/all`, p);

/*
 * 客户营销会员分群分页获取商家sku列表
 * */
// export const getTaobaoItemListSku = p => get(`${RESOURCE_BASE_PATH}/sku/page`, p);
export const getTaobaoItemListSku = p => getPoint(`${RESOURCE_BASE_PATH}/sku/page`, p);

/*
 * 删除商品监控
 * */
export const delBindsell = p => put(`/sku/monitor/bindSell/${p}`);

/*
 * 添加商品监控
 * */
export const addBindsell = p => postJson(`/sku/monitor/bindSell`,p);
/*
 * 商品监控数
 * */
export const count = p => get(`/sku/monitor/bindSell/count`,p);